import {CompanyRepository} from "@modules/onBoarding/application/port/output/CompanyRepository";
import {SearchRequest} from "@modules/onBoarding/domain/SearchRequest";
import {Company} from "@modules/onBoarding/domain/Company";
import {BVDCompanyDao} from "@modules/onBoarding/infrastructure/dao/BVDCompanyDao";
import {BVDCompanyDTO} from "@modules/onBoarding/infrastructure/dto/BVDCompanyDTO";

export class BVDCompanyRepository implements CompanyRepository {

    private bvdCompanyDao: BVDCompanyDao;

    constructor(bvdCompanyDao: BVDCompanyDao) {
        this.bvdCompanyDao = bvdCompanyDao;
    }

    async getCompanies(searchRequest: SearchRequest): Promise<Company[]> {
        const apiKey: string = this.getApiKey();
        const apiUrl: string = this.getApiUrl();

        const bvdCompaniesDTO: BVDCompanyDTO[] = await this.bvdCompanyDao.getCompanies(searchRequest, apiUrl, apiKey);

        return this.mapToCompanies(bvdCompaniesDTO);
    }

    private getApiKey(): string {
        return document.getElementById('serviceLoginApiKey').getAttribute('value');
    }

    private getApiUrl(): string {
        return document.getElementById('serviceLoginUrl').getAttribute('value');
    }

    private mapToCompanies(bvdCompaniesDTO: BVDCompanyDTO[]): Company[] {
        return bvdCompaniesDTO.map(bvdCompanyDTO => {
            return new Company(
                bvdCompanyDTO.bvdId,
                bvdCompanyDTO.europeanVatNumber,
                bvdCompanyDTO.bvdMatchDTO.name,
                bvdCompanyDTO.bvdMatchDTO.nameInternational,
                bvdCompanyDTO.bvdMatchDTO.address,
                bvdCompanyDTO.bvdMatchDTO.postcode,
                bvdCompanyDTO.bvdMatchDTO.city,
                bvdCompanyDTO.bvdMatchDTO.country
            );
        });
    }

}
